import { ClipboardList, Info } from 'lucide-react';

interface EmptyStateProps {
  message: string;
}

export const AnalyticsEmptyState = ({ message }: EmptyStateProps) => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center py-20 px-4 bg-white rounded-xl">
      <div className="relative mb-6">
        <ClipboardList className="w-16 h-16 text-gray-300" />
        <Info className="w-4 h-4 text-gray-300 absolute -top-1 -right-1" />
      </div>
      <p className="text-gray-500 text-center">{message}</p>
    </div>
  );
};
